/**
 * @Author: l_hc
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-09-06 08:52:16
 * @LastEditTime: 2019-09-30 11:17:41
 * @Version: 1.0
 * @Description: 简介
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks:
 */

// 首页接口
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 统计数据获取
export const countData = () => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/home`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCount'
      }))
    }
  })
}

// 货源量
export const columnGoods = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/goods`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findGoodsCount'
      }, params))
    }
  })
}
// 入驻车辆
export const columnSettled = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/authentication`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCarCount'
      }, params))
    }
  })
}
// 交易量汇总
export const columnTrade = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/order`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findOrderCount'
      }, params))
    }
  })
}
// 云仓面积
export const columnCloud = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/authentication`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findStorageCount'
      }, params))
    }
  })
}
// 罐区容积
export const columnPot = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/authentication`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPotCount'
      }, params))
    }
  })
}

// 货源列表
export const sourceList = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/goods`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findGoodsList'
      }, params))
    }
  })
}
// 运力列表
export const TransportList = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/transport`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTransportList'
      }, params))
    }
  })
}

export const getHotDataList = () => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/home`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findHotData'
      }))
    }
  })
}

// 热门起运地
export const hotOrigin = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/transport`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findHotStartPlace'
      }, params))
    }
  })
}
// 热门目的地
export const hotDestination = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/transport`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findHotStopPlace'
      }, params))
    }
  })
}
// 热门运输方式
export const hotMode = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/transport`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTransportWay'
      }, params))
    }
  })
}

// 企业热榜
export const enterpriseHot = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/companyHotTop`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCompanyHotTop'
      }, params))
    }
  })
}
// 实时交易
export const realtimeDeal = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/order`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findSpotDeals'
      }, params))
    }
  })
}
// 价格指数（图表）
// export const priceIndex = params => {
//   return logistice({
//     url: `${LOGISTICE_GATEWAY}/website/index/order`,
//     method: 'post',
//     params: {
//       params: JSON.stringify(Object.assign({
//         methodName: 'findMoneyCompute'
//       }, params))
//     }
//   })
// }
export const priceIndex = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/price`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getPriceStatistics'
      }, params))
    }
  })
}
// 地图统计
export const mapTotal = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/authentication`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCompanyCount'
      }, params))
    }
  })
}
// 地图渲染
export const mapData = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/authentication`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findProvinceCompanyCount'
      }, params))
    }
  })
}
export const mapData2 = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/authentication`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findAuthList'
      }, params))
    }
  })
}
